import { css } from 'linaria';

export const reviewFormWrapper = css`
  width: 100%;
  padding-bottom: 80px;
`;

export const mainSection = css`
  margin-top: unset !important;
`;

export const formPartHeader = css`
  display: block;
  margin-bottom: var(--space-200) !important;
`;

export const partPhotoContainer = css`
  margin-top: var(--space-600);
  margin-bottom: var(--space-600);
`;

export const formPartPhotoStatus = css`
  margin-top: var(--space-200);
`;

export const ratingScore = css`
  width: 280px;
`;

export const scoreFieldLayout = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
`;
export const scoreFieldLayoutColumn = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
`;
export const scoreFieldCaption = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-basis: 100%;
  margin-left: 24px;
  align-items: center;
`;
export const scoreDetailFieldCaption = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-basis: 100%;
  margin-top: 4px;
  margin-left: 24px;
`;
export const scoreFieldCaptionAtColumn = css`
  display: block;
  flex-basis: 16px;
  margin-top: 16px;
  margin-left: 0px;
`;

export const shopSelectorDropdown = css`
  width: 380px;
  margin-bottom: 28px;
  --dropdown-text-bg: none;
`;

export const authorDetailInput = css`
  width: 380px;
`;

export const authorDetailInputAtMobile = css`
  width: 100%;
  [data-testid='dropdown-value'] {
    --dropdown-text-bg: var(--background-primary) !important;
  }
`;

export const textareaField = css`
  margin-top: var(--space-150);
  margin-bottom: var(--space-200);
`;

export const textareaFieldStatus = css`
  display: flex;
  flex-direction: row;
  min-height: 20px;
  margin-top: 4px;
  padding-left: var(--space-150);
`;

export const textareaFieldCounters = css`
  flex-shrink: 0;
  padding-left: 8px;
`;

export const textareaFieldCaption = css`
  flex-basis: 100%;
`;

export const inputField = css`
  margin-top: var(--space-350);
  margin-bottom: var(--space-150);
`;

export const sectionTitle = css`
  margin: var(--space-500) 0 var(--space-400) !important;
`;

export const sectionTitleAtMobile = css`
  margin-bottom: 24px;
`;

export const formLayout = css`
  display: flex;
  justify-content: space-between;
  direction: row;
`;

export const formLayoutAtMobile = css`
  display: flex;
  flex-direction: column;
`;

export const layoutMain = css`
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 580px;
`;

export const layoutSide = css`
  display: block;
  flex-basis: 430px;
`;

export const layoutSideAtMobile = css`
  display: block;
  order: -1;
  flex-basis: 100%;
  margin-bottom: 32px;
`;

export const submitButton = css`
  margin-top: var(--space-100);
  margin-bottom: var(--space-300);
`;

export const submitButtonAtMobile = css`
  width: 100%;
`;
